import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@lockton-apps/material';

import { ToolBarModule } from '../toolbar';
import { SearchFieldModule } from '../search-field';
import { FaqSection } from '../faq-accordion';

@Component({
    selector: 'lui-faq-toolbar',
    imports: [
        CommonModule,
        ToolBarModule,
        RouterModule,
        MaterialModule,
        ReactiveFormsModule,
        SearchFieldModule,
    ],
    templateUrl: './faq-toolbar.component.html',
    styleUrls: ['./faq-toolbar.component.scss']
})
export class FaqToolbarComponent {
  @Input() searchControl!: FormControl;
  @Input() searchOptions!: FaqSection[] | null;
  @Output() searchOptionClick = new EventEmitter<{
    sectionId: number;
    questionId: number;
  }>();

  onOptionClicked(sectionId: number, questionId: number) {
    this.searchOptionClick.emit({ sectionId, questionId });
    this.searchOptions = [];
  }
}
